export default __webpack_public_path__ + "static/media/slider-img1.0f4138d6.gif";